import React from 'react';
import { useTheme, withTheme } from 'react-jss';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

const defaultGetStyles = () => ({});

export function withRawStyles(WrappedComponent, getStyles = defaultGetStyles) {
  const StyledComponent = withTheme((props) => {
    const { theme, ...rest } = props || {};
    const { components = {}, core = {} } = theme || {};
    const styles = getStyles(components, core);
    return <WrappedComponent {...rest} styles={styles} />;
  });

  StyledComponent.displayName = `withFluentUIStyles(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(StyledComponent, WrappedComponent);

  return StyledComponent;
}

export function useRawStyles(getStyles = defaultGetStyles) {
  const theme = useTheme();
  const { components = {}, core = {} } = theme || {};
  const styles = getStyles(components, core);
  return styles;
}
